import React from "react";
import { useTheme } from "styled-components";
import styled from "styled-components";
import miniclose from "../img/icons/miniclose.svg";
import CreatableSelect from "react-select/creatable";

const Remove = styled.div`
  width: 18px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 6px;
    height: 6px;
  }
`;

const components = {
  DropdownIndicator: null,
  MultiValueRemove: (events) => (
    <Remove
      onClick={() => {
        events.innerProps.onClick();
      }}
    >
      <img src={miniclose} alt="x" />
    </Remove>
  ),
};

const CreatableInputOnly = ({ tags, settags, maxTags, placeholder, alert }) => {
  const theme = useTheme();

  const customStyles = {
    multiValueRemove: (provided) => ({
      ...provided,
    }),
    multiValue: (provided) => ({
      ...provided,
      background: theme.color.primary,
      borderRadius: "5px",
      display: "flex",
      alignItems: "center",
      overflow: "hidden",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      padding: "0px",
      marginLeft: "6px",
      color: "white",
      fontFamily: "Poppins bold, sans-serif",
      letterSpacing: "0.02em",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "10px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme.color.darkerText,
      fontFamily: "Poppins Regular",
    }),
    input: (provided) => ({
      ...provided,
      color: theme.color.darkerText,
      fontFamily: "Poppins Regular",
    }),
    placeholder: (defaultStyles) => ({
      ...defaultStyles,
      color: theme.color.lighterText,
      opacity: "0.4",
      userSelect: "none",
      textTransform: "capitalize",
      fontSize: "14px",
      fontFamily: "Poppins, sans-serif",
      fontWeight: "400",
    }),
    control: (base, state) => ({
      ...base,
      borderRadius: "5px",
      border: "none",
      cursor: "text",
      paddingLeft: "5px",
      color: theme.color.darkerText,
      fontSize: theme.fontSize.xs,
      background: alert ? "rgba(238, 76, 80, 0.05)" : theme.color.secondaryBg,
      boxShadow: alert
        ? "0 0 0 0.13rem rgba(238, 76, 80, 0.8)"
        : state.isFocused
          ? "0 0 0 0.2rem rgba(69, 105, 255, 0.8)"
          : null,
    }),
    menu: (base) => ({
      ...base,
      background: theme.color.background,
      borderRadius: "5px",
      border: "1px solid " + theme.color.border,
      color: theme.color.darkerText,
      fontSize: theme.fontSize.xs,
    }),
    option: (base) => ({
      ...base,
      cursor: "pointer",
      background: theme.color.background,
      color: theme.color.darkerText,
      fontSize: theme.fontSize.xs,
      fontFamily: "Poppins Regular",
      "&:hover": {
        background: theme.color.secondaryBg,
      },
    }),
  };

  const handleChange = (value) => {
    settags(value || []);
  };

  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <CreatableSelect
        styles={customStyles}
        components={components}
        isClearable
        isMulti
        onChange={handleChange}
        placeholder={placeholder}
        value={tags}
      />
    </div>
  );
};

export default CreatableInputOnly;
